import Cookies from 'js-cookie';
import { BFFHttpError } from '../bff-api/model/BFFHttpError';
import { RecaptchaErrorCode } from './recaptcha';
import type { RecaptchaErrorResponse } from './recaptcha';

const COOKIE_NAME_KIOSK_LOCATION_ID = 'kiosk_location_id';

export function isRecaptchaError(error: unknown): error is BFFHttpError & {
    body: RecaptchaErrorResponse;
} {
    if (!(error instanceof BFFHttpError)) {
        return false;
    }

    if (![400, 401].includes(error.status)) {
        return false;
    }

    const body = error.body as Partial<RecaptchaErrorResponse>;

    return (
        typeof body?.errorCode === 'string' &&
        body.errorCode.startsWith('RECAPTCHA_') &&
        Object.values(RecaptchaErrorCode).includes(body.errorCode as RecaptchaErrorCode)
    );
}

export const getKioskLocationId = (): string | null => {
    let kioskLocationId: string | null | undefined = Cookies.get(COOKIE_NAME_KIOSK_LOCATION_ID);
    if (!kioskLocationId) {
        kioskLocationId = window.localStorage.getItem('kiosk_location_id');
    }
    return kioskLocationId || null;
};
